export default __webpack_public_path__ + "static/media/new-4.e40d8fde.png";